export default __webpack_public_path__ + "static/media/sq99mall-shops.d9590f75.jpg";